export default __webpack_public_path__ + "img/reward_3-f7ba502c.png";